import axios from "axios";

// Single shared axios instance. withCredentials is the one change
// every existing call site needs: without it, the browser won't send
// the httpOnly auth cookie the new backend auth middleware relies on,
// and every protected route will 401 even right after a successful
// login.
const apiClient = axios.create({
  withCredentials: true,
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // REGRESSION FIX: this used to fire on ANY 401 from ANYWHERE,
      // including calls made by an anonymous visitor who was never
      // logged in — a 401 for a logged-out visitor hitting a
      // protected endpoint is a normal, expected outcome, not
      // evidence of an expired session, and shouldn't force-navigate
      // someone away from a page they're allowed to be browsing (see
      // useServerRole's 401 on the homepage/public shop pages for the
      // concrete case this broke). Only clear storage and redirect
      // when there actually WAS a cached session — that's the only
      // case a 401 genuinely means "you got logged out."
      const hadSession = !!localStorage.getItem(process.env.REACT_APP_LOCALHOST_KEY);

      if (hadSession) {
        localStorage.removeItem(process.env.REACT_APP_LOCALHOST_KEY);
        if (!window.location.hash.includes("/login")) {
          window.location.hash = "#/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
